import { render, staticRenderFns } from "./WaterwayDetail.vue?vue&type=template&id=5f989fd8&scoped=true&"
import script from "./WaterwayDetail.vue?vue&type=script&lang=js&"
export * from "./WaterwayDetail.vue?vue&type=script&lang=js&"
import style0 from "./WaterwayDetail.vue?vue&type=style&index=0&id=5f989fd8&lang=scss&scoped=true&"
import style1 from "./WaterwayDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f989fd8",
  null
  
)

export default component.exports